<template>
  <div class="login-container">
    <!-- 全屏加载状态 -->
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在准备登录环境..."></div>

    <!-- 登录卡片 -->
    <el-card class="login-card" v-if="!fullscreenLoading">
      <!-- 系统Logo和标题 -->
      <div class="login-header">
        <div class="logo"></div>
        <h2 class="system-title">物流比价订舱系统</h2>
        <p class="system-desc">专业的物流服务商报价管理平台</p>
      </div>

      <!-- 登录内容区 -->
      <div class="login-content">
        <el-divider content-position="left">请使用微信登录</el-divider>

        <p class="login-tips">本系统仅支持企业微信授权登录，请确保您已获得系统使用权限</p>

        <!-- 微信登录按钮 -->
        <el-button
                class="wechat-login-btn"
                type="primary"
                round
                icon="el-icon-wechat"
                @click="handleWechatLogin"
                :loading="loginLoading"
        >
          微信快捷登录
        </el-button>

        <!-- 登录状态提示 -->
        <el-alert
                v-if="loginError"
                :message="errorMsg"
                type="error"
                show-icon
                :closable="false"
                class="login-alert"
        ></el-alert>
      </div>
    </el-card>

    <!-- 页脚信息 -->
    <div class="login-footer">
      <p>© 2025 物流比价订舱系统 版权所有</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "login",
    data() {
      return {
        fullscreenLoading: true,
        loginLoading: false,
        loginError: false,
        errorMsg: '',
        url: {
          getWxgzh: "/h5/getWxgzh",
          oauthUrl: "/h5/oauthUrl",
        }
      }
    },
    created() {
      this.initLoginProcess();
    },
    methods: {
      /**
       * 初始化登录流程
       */
      initLoginProcess() {
        // 检查是否有redirect参数并保存
        if (this.$route.query.redirect) {
          localStorage.setItem('login_redirect', this.$route.query.redirect);
        }
        this.isWeiXin();
      },

      /**
       * 判断是否在微信环境
       */
      isWeiXin() {
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.indexOf('micromessenger') > -1) {
          console.log('检测到微信环境');
          const code = this.getQueryParam('code');
          if (code) {
            // URL 上有 code，直接换 token
            this.onWXinLogin(code);
          } else {
            // 没有 code，先去获取授权链接
            this.fullscreenLoading = false;
            this.getOauthUrl();
          }
        } else {
          this.fullscreenLoading = false;
          this.loginError = true;
          this.errorMsg = '请在微信客户端中打开以完成登录';
        }
      },

      /**
       * 微信登录按钮点击处理
       */
      handleWechatLogin() {
        this.loginLoading = true;
        this.loginError = false;
        this.getOauthUrl();
      },

      /**
       * 微信授权登录处理 - 用 code 换 token
       */
      onWXinLogin(code) {
        const params = {
          'code': code,
          'appname': 'labor'
        };

        this.$get(this.url.getWxgzh, params)
                .then((data) => {
                  this.loginLoading = false;
                  this.fullscreenLoading = false;

                  if (data.code === 200 && data.message) {
                    // 登录成功，保存token并跳转
                    localStorage.setItem('X-Access-Token', data.message);
                    const redirectUrl = localStorage.getItem('login_redirect') || '/offerprice';
                    localStorage.removeItem('login_redirect'); // 用完即清理
                    this.$router.replace(redirectUrl);
                  } else if (data.code === 500 && data.message === "该用户不存在") {
                    this.loginError = true;
                    this.errorMsg = '该用户不存在，请联系管理员开通权限';
                  } else {
                    // code 无效，清除后重新获取授权
                    this.removeCodeFromUrl();
                    this.getOauthUrl();
                  }
                })
                .catch((err) => {
                  console.error('登录请求失败:', err);
                  this.loginLoading = false;
                  this.fullscreenLoading = false;
                  this.loginError = true;
                  this.errorMsg = '登录失败，请重试';
                });
      },

      /**
       * 获取授权URL并跳转
       */
      getOauthUrl() {
        this.removeCodeFromUrl();

        const oauthCallback = encodeURI(`${window.location.protocol}//${window.location.host}/login`);
        const params = {
          'oauth_callback': oauthCallback,
          'appname': 'labor'
        };

        this.$get(this.url.oauthUrl, params)
                .then((res) => {
                  this.loginLoading = false;
                  if (res.message) {
                    window.location.href = res.message;
                  } else {
                    this.loginError = true;
                    this.errorMsg = '获取授权链接失败，请重试';
                  }
                })
                .catch((err) => {
                  console.error('获取授权URL失败:', err);
                  this.loginLoading = false;
                  this.fullscreenLoading = false;
                  this.loginError = true;
                  this.errorMsg = '获取授权链接失败，请重试';
                });
      },

      /**
       * 从 URL 获取查询参数
       */
      getQueryParam(name) {
        try {
          const url = new URL(window.location.href);
          return url.searchParams.get(name);
        } catch (e) {
          return null;
        }
      },

      /**
       * 清除URL中的code参数
       */
      removeCodeFromUrl() {
        try {
          const url = new URL(window.location.href);
          if (url.searchParams.has('code')) {
            url.searchParams.delete('code');
            window.history.replaceState({}, document.title, url.toString());
          }
        } catch (e) {
          console.error('清除URL参数失败:', e);
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  /* 样式保持不变 */
  .login-container {
    min-height: 100vh;
    background-color: #f5f7fa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }

  .login-card {
    width: 100%;
    max-width: 420px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: none;

    /deep/ .el-card__body {
      padding: 0;
    }
  }

  .login-header {
    background-color: #2196F3;
    color: #fff;
    padding: 30px 20px;
    text-align: center;

    .logo {
      width: 60px;
      height: 60px;
      margin: 0 auto 15px;
      background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzg0IDM1MmgtMTYwVjE2MEg1MDJ2MTkyYzAg2y45LTE3LjEgMjAtMzYuOSAyMEgzODR6TTI1NiAxNjB2MTkyaDE2MHYtMTkySDI1NnoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjU2IDBoLTgwdjUyYzAtMzguOS0xNC42LTQwLTM2LjktNDBoLTR4LTQwYzAgMjAuOS0xNy4xIDIwLTM2LjkgMjB2NDhoLTQwVjBIMThDMTEuMiAwIDAgMTEuMiAwIDE4LjV2NDc1YzAgNy4zIDExLjIgMTguNSAxOCAxOC41aDQ3NmM3LjMgMCAxOC0xMS4yIDE4LTE4LjVWMThjMC03LjMtMTEuMi0xOC41LTE4LTE4LjV6TTM3NiA0MzJINTEyVjE5NGgtMTM2djI1NnoiLz48L3N2Zz4=') no-repeat center;
      background-size: contain;
    }

    .system-title {
      margin: 0 0 8px;
      font-size: 22px;
      font-weight: 600;
    }

    .system-desc {
      margin: 0;
      font-size: 14px;
      opacity: 0.9;
    }
  }

  .login-content {
    padding: 30px 20px;
  }

  /deep/ .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .login-tips {
    color: #666;
    font-size: 13px;
    text-align: center;
    margin: 0 0 25px;
    line-height: 1.6;
  }

  .wechat-login-btn {
    width: 100%;
    height: 48px;
    font-size: 16px;
    padding: 0;
    margin-bottom: 20px;
  }

  .login-alert {
    margin-top: 15px;
  }

  .login-footer {
    margin-top: 30px;
    text-align: center;

    p {
      color: #999;
      font-size: 12px;
      margin: 0;
    }
  }

  @media screen and (max-width: 768px) {
    .login-header {
      padding: 25px 15px;

      .logo {
        width: 50px;
        height: 50px;
      }

      .system-title {
        font-size: 20px;
      }
    }

    .login-content {
      padding: 25px 15px;
    }

    .wechat-login-btn {
      height: 44px;
      font-size: 15px;
    }
  }
</style>